/**
 * Created by Ramon Wenger on 14/06/18.
 * Copyright (c) 2018 ITerativ GmbH. All rights reserved.
 */

import { type } from '../shared/util';
import { Action } from "@ngrx/store";
import { PaymentRequest } from "./payment.models";

export const PaymentActionTypes = {
    GET_PAYMENT_REQUEST: type("[Payment] Get Payment Request"),
    GET_PAYMENT_REQUEST_SUCCESS: type("[Payment] Get Payment Request Success"),
    GET_PAYMENT_REQUEST_FAILURE: type("[Payment] Get Payment Request Failure"),
    RESET_PAYMENT: type("[Payment] Reset"),
    SET_PROMOTION_ERRORS: type('[Payment] Set Promotion Errors')
};


export class GetPaymentRequestAction implements Action {
    type = PaymentActionTypes.GET_PAYMENT_REQUEST;

    constructor(public payload: string) {
    }
}

export class GetPaymentRequestSuccessAction implements Action {
    type = PaymentActionTypes.GET_PAYMENT_REQUEST_SUCCESS;

    constructor(public payload: PaymentRequest) {
    }
}

export class GetPaymentRequestFailureAction implements Action {
    type = PaymentActionTypes.GET_PAYMENT_REQUEST_FAILURE;

    constructor() {
    }
}

export class ResetPaymentAction implements Action {
    type = PaymentActionTypes.RESET_PAYMENT;

    constructor() {
    }
}

export class SetPromotionErrors implements Action {
    type = PaymentActionTypes.SET_PROMOTION_ERRORS;

    constructor(public payload: Object) {
    }
}
